import React from 'react';

import * as styles from './style.css';

export const PhonesPreloader = () => {
  return <div className={styles['loader']}></div>;
};
